<template>
  <div
    class="catalog-products"
    :class="{'catalog-products--main-page': mainPage, 'loaded': emptyProducts, 'page-container': withContainer}">
    <h3
      v-if="title"
      class="catalog-products__title">{{ title }}</h3>
    <CategoryFilter
      v-if="filterData"
      :data="filterData"
      @change-filter="handleChangeFilter"
      without-container
    />
    <div v-if="emptyProducts" v-html="$t('empty_products_catalog')" class="empty-products"></div>
    <InfiniteScroll
      v-else
      v-observe-visibility="catalogVisibility"
      :getInfoAction="FETCH_PRODUCTS_INFO"
      :action-params="{ endpoint, type, productUid, categoryId }"
      :goodsLeft="goodsLeft"
      :itemsList="products"
      :offset="offset"
      :isLoading="isLoading"
      :main-page="mainPage"
      :product-page="productPage"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import InfiniteScroll from '../components/helpers/InfiniteScroll'
import CategoryFilter from '../components/product/product-block/CategoryFilter'

export default {
  name: 'Catalog',
  components: { CategoryFilter, InfiniteScroll },
  data () {
    return {
      isCatalogVisible: false,
      isFirstLoad: true,
      categoryId: ''
    }
  },
  props: {
    data: {
      type: [Object, Array],
      default: null
    },
    endpoint: {
      type: String,
      required: true
    },
    productUid: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    mainPage: {
      type: Boolean,
      default: false
    },
    productPage: {
      type: Boolean,
      default: false
    },
    withContainer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      productsInfo: state => state.products.productsInfo,
      isLoading: state => state.products.isLoading,
      products: state => state.products.products,
      filterData: state => state.products.filterData,
      emptyProducts: state => state.products.emptyProducts
    }),
    goodsLeft () {
      return this.productsInfo ? this.productsInfo.goods_left : 0
    },
    offset () {
      return this.productsInfo ? this.productsInfo.offset : 0
    }
  },
  methods: {
    ...mapActions(['FETCH_PRODUCTS_INFO']),
    ...mapMutations(['CLEAR_PRODUCTS_INFO', 'SET_PRODUCTS_INFO']),
    catalogVisibility (isVisible) {
      this.isCatalogVisible = isVisible
    },
    handleChangeFilter (value) {
      this.CLEAR_PRODUCTS_INFO()
      this.categoryId = value.id
      this.fetchProductsInfo()
    },
    fetchProductsInfo () {
      this.FETCH_PRODUCTS_INFO({
        endpoint: this.endpoint,
        productUid: this.productUid,
        type: this.type,
        categoryId: this.categoryId
      })
    }
  },
  watch: {
    isCatalogVisible (value) {
      if (value && this.mainPage && this.isFirstLoad) {
        this.fetchProductsInfo()
        this.isFirstLoad = false
      }
    }
  },
  mounted () {
    if (!this.mainPage && !this.productPage) {
      if (this.data) {
        this.SET_PRODUCTS_INFO(this.data)
      } else {
        this.fetchProductsInfo()
      }
    }
  },
  destroyed () {
    this.CLEAR_PRODUCTS_INFO()
  }
}
</script>

<style lang="sass">
.catalog-products
  width: 100%

.show-more
  margin: 0 auto

.catalog-products--main-page
  margin-top: 30px
  display: none
  &.loaded
    display: block

  +mmin($tablet)
    margin-top: 60px

.catalog-products__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0 0 15px

  +mmin($tablet)
    font-size: 24px
    margin: 0 0 30px

.empty-products
  min-height: 500px
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  width: 100%

.empty-products__svg
  margin-bottom: 30px
</style>
